function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Component } from 'react';
import snakeCase from 'lodash.snakecase';
import { Headline, Body } from '@airwallex/typography';
import { IconClose } from '@airwallex/glyphs';
import AlertIcon from './icon';
import { AlertStyle, ContentContainer, CloseButton, ActionContainer, ActionButton, AlertIconStyle, AlertTextLinkStyles } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AlertTextLink = function AlertTextLink(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return ___EmotionJSX(AlertTextLinkStyles, props, children);
};
export var Alert = /*#__PURE__*/function (_Component) {
  _inherits(Alert, _Component);

  var _super = _createSuper(Alert);

  function Alert(props) {
    var _this;

    _classCallCheck(this, Alert);

    _this = _super.call(this, props);
    _this.state = {
      showAlert: true
    };
    return _this;
  }

  _createClass(Alert, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          hide = _this$props.hide,
          icon = _this$props.icon,
          syncing = _this$props.syncing,
          heading = _this$props.heading,
          btnText = _this$props.btnText,
          btnAction = _this$props.btnAction,
          linkText = _this$props.linkText,
          linkAction = _this$props.linkAction,
          dismiss = _this$props.dismiss,
          variant = _this$props.variant,
          etc = _objectWithoutProperties(_this$props, ["children", "hide", "icon", "syncing", "heading", "btnText", "btnAction", "linkText", "linkAction", "dismiss", "variant"]);

      var showAlert = this.state.showAlert;

      if (hide || !showAlert) {
        return null;
      }

      var isCompact = typeof children === 'undefined' && typeof heading !== 'undefined' || typeof heading === 'undefined' && typeof children !== 'undefined';
      var layout = btnAction ? 'withAction' : dismiss ? 'withDismiss' : linkAction ? 'withLinkAction' : 'default';
      return ___EmotionJSX(AlertStyle, _extends({
        layout: layout,
        variant: variant,
        icon: icon,
        compact: isCompact,
        "data-test": snakeCase("alert-".concat(heading || 'hook'))
      }, etc), ___EmotionJSX(AlertIconStyle, {
        variant: variant
      }, ___EmotionJSX(AlertIcon, {
        variant: variant
      })), ___EmotionJSX(ContentContainer, {
        compact: isCompact
      }, heading && ___EmotionJSX(Headline, {
        variant: "400"
      }, heading), children && ___EmotionJSX(Body, null, children)), layout === 'withDismiss' && ___EmotionJSX(CloseButton, {
        variant: "DEFAULT",
        onClick: dismiss,
        link: true
      }, ___EmotionJSX(IconClose, {
        size: 16
      })), layout === 'withAction' && ___EmotionJSX(ActionContainer, {
        compact: isCompact,
        layout: layout
      }, ___EmotionJSX(ActionButton, {
        variant: "SECONDARY",
        onClick: btnAction,
        syncing: syncing
      }, btnText || 'Button')), layout === 'withLinkAction' && ___EmotionJSX(ActionContainer, {
        layout: layout
      }, ___EmotionJSX(Body, null, ___EmotionJSX(AlertTextLink, {
        onClick: linkAction
      }, linkText || 'Link'))));
    }
  }]);

  return Alert;
}(Component);
export * from './types';
export default Alert;